export const MAP = 1;

export const FILTER = 2;

export const PRODUCT = 3;

export const LOW_TO_HIGH = "Low to high";

export const HIGH_TO_LOW = "High to low";

export const NEWEST = "Newest";

export const TOP_REVIEW = "Top review";

export const NEAR_BY = "Nearby";

export const sort = (type, [a, b]) => {
  switch (type) {
    case NEWEST:
      return new Date(b.public_date) - new Date(a.public_date);
    case TOP_REVIEW:
      return b.rating - a.rating;
    case HIGH_TO_LOW:
      return b.price - a.price;
    case LOW_TO_HIGH:
      return a.price - b.price;
    default:
      return 0;
  }
};
